module.exports = __webpack_public_path__ + "static/Louis-et-Adrien.2cedeb3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Louis-et-Adrien.jpg
// module id = 461
// module chunks = 35783957827783